module.exports = __webpack_public_path__ + "img/get_cash_quickly.8d07c194.svg";